module.exports = "<p>\n  market-cart works!\n</p>\n"